import { render, staticRenderFns } from "./LayoutSuperAdmin.vue?vue&type=template&id=3efcb5a8&"
import script from "./LayoutSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./LayoutSuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSuperAdmin.vue?vue&type=style&index=0&id=3efcb5a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports